import { COLOR_PRODUCT_OPTION_GROUP } from '~/constants'

export function useProductVariantImage() {
  const productStore = useProductStore()

  const selectedVariantImageIndex = computed(() => {
    // If all options are selected, use the selected variant's image
    if (productStore.selectedVariant?.featuredAsset?.id) {
      return productStore.images?.findIndex(image => image.id === productStore.selectedVariant?.featuredAsset?.id) ?? 0
    }

    // If only color is selected, find a variant with that color
    const colorOption = productStore.selectedOptions[COLOR_PRODUCT_OPTION_GROUP]
    if (colorOption) {
      const colorVariant = productStore.productVariants?.find(v =>
        v.options?.some(option => option.group.code === COLOR_PRODUCT_OPTION_GROUP && option.code === colorOption),
      )
      if (colorVariant?.featuredAsset?.id) {
        return productStore.images?.findIndex(image => image.id === colorVariant.featuredAsset?.id) ?? 0
      }
    }

    return 0
  })

  const variantImage = computed(() => {
    // If all options are selected, use the selected variant's image
    if (productStore.selectedVariant?.featuredAsset?.preview) {
      return productStore.selectedVariant.featuredAsset.preview
    }

    // If only color is selected, find a variant with that color
    const colorOption = productStore.selectedOptions[COLOR_PRODUCT_OPTION_GROUP]
    if (colorOption) {
      const colorVariant = productStore.productVariants?.find(v =>
        v.options?.some(option => option.group.code === COLOR_PRODUCT_OPTION_GROUP && option.code === colorOption),
      )
      if (colorVariant?.featuredAsset?.preview) {
        return colorVariant.featuredAsset.preview
      }
    }

    // Fallback to product image
    return productStore.product?.featuredAsset?.preview
  })

  return {
    selectedVariantImageIndex,
    variantImage,
  }
}
